import Konva from 'konva';
import { AnyIfEmpty } from 'react-redux';
import { dropInArtboard } from '@utils/editor';
import { ISelectorConfig } from '@state/dsconfig/types';
import { ISelectorProps } from '@routes/private/Editor/Editor/Canvas/types';

export const updateNodes = (selectorTrRef:any) => {
    let selectorNodes =  selectorTrRef.getNodes();
    selectorNodes.forEach((node: any) => node.fire("dragend"));
};

export const initSelectionRect = (e:any, selectorProps: any, layerRef: any) => {
    if (!e.evt.shiftKey) return;
    const pos = layerRef.current.getRelativePointerPosition();
    selectorProps.current.selecting = true;
    selectorProps.current.mouseDown = true;
    selectorProps.current.x1 = pos.x;
    selectorProps.current.y1 = pos.y;
    selectorProps.current.x2 = pos.x;
    selectorProps.current.y2 = pos.y;
}

export const updateSelectionRect = (selector: any, selectorProps:any, layerRef:any, setSelectedNodes:any, selectorConfig: ISelectorConfig) => {
  const node = selector.current;
  let width = Math.abs(selectorProps.current.x1 - selectorProps.current.x2);
  let height = Math.abs(selectorProps.current.y1 - selectorProps.current.y2);
  
  if (width>=selectorConfig.width || height>=selectorConfig.height){
    node.setAttrs({
      visible: selectorProps.current.visible,
      x: Math.min(selectorProps.current.x1, selectorProps.current.x2),
      y: Math.min(selectorProps.current.y1, selectorProps.current.y2),
      width: width,
      height: height,
    });

    selectOnDrag(selectorProps, node, layerRef, setSelectedNodes);
  }
};

export const handleMouseMove = (e: any, selectorProps: any, selector: any, layerRef:any, setSelectedNodes:any, selectorConfig: ISelectorConfig) => {
  if (!selectorProps.current.selecting || !selectorProps.current.mouseDown) return;
  const pos = layerRef.current.getRelativePointerPosition();
  selectorProps.current.x2 = pos.x;
  selectorProps.current.y2 = pos.y;
  selectorProps.current.visible = true;
  updateSelectionRect(selector, selectorProps, layerRef, setSelectedNodes, selectorConfig);
}

export const moveSelector = (e:any, selectorTrRef:any, deltas: any) => {
    let selectorNodes =  selectorTrRef.getNodes();

    let delta = (e.shiftKey || e.metaKey) ? deltas.fast : deltas.normal;
    let x = 0, y = 0;
    
    if (e.key === "ArrowLeft") x= x - delta;
    if (e.key === "ArrowRight") x= x + delta;
    if (e.key === "ArrowUp") y= y - delta;
    if (e.key === "ArrowDown") y= y + delta;

    selectorNodes.forEach((node: any) => {
      node.setPosition({x: node.x() + x , y: node.y() + y});
      node.fire("dragmove");
    });
}

 export const cleanSelector =  (selector: any, selectorProps:any, layerRef: any) => {
    if (selector.current) {
      selector.current.detach();
      selector.current.nodes([]);
    }

    if ( selectorProps.current) selectorProps.current = {
        selecting: false,
        visible: false,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        nodesUpdateInfo: [] as any
      };
 }

export const selectOnDrag = (selectorProps: any, selector: any, layerRef:any, setSelectedNodes:any) => {
    if (!selectorProps.current.selecting || !selectorProps.current.mouseDown) return;
    
    if (selectorProps.current.selecting) {
      let selectedelements : string[] = []
      const elements: any = [];
      const selBox = selector.getClientRect();
      layerRef.current.getChildren().forEach((groupElementNode: any) => {
        const elBox = groupElementNode.attrs.type === "artboard" ? groupElementNode.children[0].getClientRect() : null;
        if (elBox && Konva.Util.haveIntersection(selBox, elBox)) {
          groupElementNode.children?.forEach((childrenNode: any) => {
            const childBox = childrenNode.getClientRect();
            if (Konva.Util.haveIntersection(selBox, childBox) 
              && childrenNode.attrs.id && childrenNode.attrs.visible && childrenNode.attrs.locked!==true) {
                selectedelements.push(childrenNode.attrs.id);
                elements.push(childrenNode);
            }
          })
        }
      });
      setSelectedNodes(selectedelements);
    }
}

export const insideSelector = (selectorProps: ISelectorProps, id: string, ids: string[]) => {
    if (!selectorProps.selecting || !selectorProps.mouseDown) return false;
    return ids.includes(id);
}

export const addToSelector = (layerRef: any, selectorTrRef: React.MutableRefObject<Konva.Transformer>, ids: string[], lockIconRef: React.MutableRefObject<Konva.Image>, hasElementLocked: boolean) => {
  let elements: any = [];
  elements = getSelectedNodes(layerRef.current, ids, elements);
  if (elements.length>1) {
    selectorTrRef.current.nodes(elements);
    selectorTrRef.current?.getLayer()?.batchDraw(); 
  }

  updateSelectorIcon(selectorTrRef.current, lockIconRef.current, hasElementLocked);
}

export const getSelectedNodes = (element: any, ids: string[], selectedElements: any) => {
  if (ids.includes(element.attrs.id)) selectedElements.push(element);
  element.children?.forEach((childrenNode: any) => {
    selectedElements = getSelectedNodes(childrenNode, ids,selectedElements)
  });
    
  return selectedElements;
}

export const getSelectorNode = (layerRef: any) => {
  let selectorNode: any | undefined = undefined;
  if (layerRef.current.children) {
    
    layerRef.current.children.forEach((element: any)=>{
      if (element.attrs.name==="selector-trf") selectorNode = element;
    });
  }
  return selectorNode;
}

export const getElementsResize = (selectedElementsId: any, selectorProps:any) => {
  let orderValues : any[] = [];  
  selectedElementsId.map((id:string) => {
    let node = selectorProps.current.nodesUpdateInfo.find( (item:any) => item.id === id);  
    if (node!==undefined) orderValues.push(node);
  });
  selectorProps.current.nodesUpdateInfo = [];
  return orderValues;
}

export const clickInsideArtboard = (stageRef: any, point: any) => {
  let allElements: any[] = stageRef.getAllIntersections(point);
  let inside: boolean = false;
  allElements.forEach((element: any)=>{
    if (element.attrs?.type==="artboard-rect") inside = true;
  });
  return inside;
}

export const getLockedIconPosition = (elements:any[]) => {
  let position: any = { x: 0, y:0};

  elements.forEach((node: any) => {
    if (node.attrs.x+node.width() > position.x) position.x = node.attrs.x+node.width();
    if (node.attrs.y+node.height() > position.y) position.y = node.attrs.y+node.height();
  });
  return position;
}

export const updateSelectorIcon = (selectorTr: Konva.Transformer | null, lockIcon: Konva.Image | null, hasElementLocked: boolean) => {
  if (lockIcon && selectorTr && hasElementLocked)
    lockIcon.setPosition({x: selectorTr.getWidth(), y: selectorTr.getHeight()});
  lockIcon?.visible(hasElementLocked);
}